<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'link-modal.insert-link'">_Insertar enlace</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-text-simple
        [field]="linkModal.urlField"
        [preSelectItem]="linkModal.url"
        (itemSelected)="itemSelected($event, 'url')">
      </field-type-text-simple>
      <field-type-text-simple
        [field]="linkModal.textField"
        [preSelectItem]="linkModal.textDisplay"
        (itemSelected)="itemSelected($event, 'textDisplay')">
      </field-type-text-simple>
      <field-type-text-simple
        [field]="linkModal.titleField"
        [preSelectItem]="linkModal.title"
        (itemSelected)="itemSelected($event, 'title')">
      </field-type-text-simple>
      <field-type-list-simple [field]="linkModal.targetField"
        [listValues]="linkModal.targetList"
        [preSelectItem]="linkModal.target"
        (itemSelected)="itemSelected($event, 'target')">
      </field-type-list-simple>
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    @if (linkModal.prevLink) {
      <button class="common-button__text-noborder"
        (click)="removeLink()">
        <span class="common-button__text-title"
          [afTranslate]="'common.remove'">_Eliminar</span>
      </button>
    }
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
      (click)="addLink()">
      <span class="common-button__text-title"
      [afTranslate]="linkModal.prevLink?'common.save':'common.insert'">_Insertar/Guardar</span>
    </button>
  </div>
</div>
